import { Injectable } from '@angular/core';
import {SessionDataModel} from "../../../../core/models/misc/session-data.model";
import {SessionStorageService} from "../session-storage/session-storage.service";
import {HttpService} from "../../rest/http-service/http.service";
import {firstValueFrom} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class SessionProviderService {
    sessionKey = "uis-user-session-id";
    private readonly APP_INFO_URL = '/api/appConfig';

    constructor(private _sessionStorageService: SessionStorageService, private _httpService: HttpService<SessionDataModel>) { }

    getSessionId() {
        let sessionData = JSON.parse(this._sessionStorageService.get(this.sessionKey));
        if (this._isExpired(sessionData)) {
            sessionData = {
                sessionId: this._generateNewSessionId(),
                generatedAt: new Date()
            };
        } else {
            sessionData.generatedAt = new Date();
        }
        this._sessionStorageService.set(this.sessionKey, JSON.stringify(sessionData));
        return sessionData.sessionId;
    }

    async validateSession(): Promise<SessionDataModel> {
        return await firstValueFrom(this._httpService.get(this.APP_INFO_URL));
    }

    _generateNewSessionId() {
        // @ts-ignore
        return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, function(char: any) {
            return (char ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> char / 4).toString(16);
        });
    }

    _isExpired(sessionData: SessionDataModel) {
        if (!sessionData) {
            return true;
        }
        // @ts-ignore
        const differenceInSeconds = (new Date() - new Date(sessionData.generatedAt)) / 1000;
        return differenceInSeconds > (60 * 15);
    }
}
